import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { roiCalculatorStyles } from "../../../../../ThemeProvider";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";

interface CarbonPriceSectionProps {
  readOnly: boolean;
}

const CarbonPriceSection: FC<CarbonPriceSectionProps> = ({ readOnly }) => {
  const intl = useIntl();
  const roiClasses = roiCalculatorStyles();

  return (
    <Box className={roiClasses.sectionColumn}>
      <Box className={roiClasses.sectionHeader}>
        <Typography variant="h6" className={roiClasses.sectionTitle}>
          {intl.formatMessage({
            id: "SUSTELL.ROI.CARBON_PRICE.TITLE",
          })}
        </Typography>
        <Typography variant="body2" className={roiClasses.sectionDescription}>
          {intl.formatMessage({
            id: "SUSTELL.ROI.CARBON_PRICE.DESCRIPTION",
          })}
        </Typography>
      </Box>

      <Box className={roiClasses.inputFieldBox}>
        <ReactHookDsmInput
          name="carbonPricePerTonne"
          label={intl.formatMessage({
            id: "SUSTELL.ROI.CARBON_PRICE.LABEL",
          })}
          adornment={intl.formatMessage({
            id: "SUSTELL.ROI.CARBON_PRICE.PLACEHOLDER",
          })}
          type="number"
          disabled={readOnly}
        />
      </Box>
    </Box>
  );
};

export default CarbonPriceSection;
